import { Button, Chip, ColorsV2, Flex, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

const MAX_IMAGES = 10;

type AssetImagesGridHeaderProps = {
  assetImagesCount: number;
  onOpenModal: () => void;
};

const AssetImagesGridHeader = ({
  assetImagesCount,
  onOpenModal,
}: AssetImagesGridHeaderProps) => {
  const { t } = useTranslation('assets');
  const enableImageUploadButton = assetImagesCount < MAX_IMAGES;

  return (
    <Flex
      width="100%"
      p="2.5rem"
      overflowX="hidden"
      vAlignContent="center"
      hAlignContent="between">
      <Flex vAlignContent="center">
        <Text variant="heading-2">{t('assetImagesGridHeader.images')}</Text>
        <Chip
          id="asset-history-count-chip"
          ml="3"
          backgroundColor={ColorsV2.PRIMARY_LIGHTEST}
          variant="small">
          <Text variant="legal" intent="brand">
            {t('assetImagesGridHeader.imagesCount', {
              count: assetImagesCount,
              max: MAX_IMAGES,
            })}
          </Text>
        </Chip>
      </Flex>
      <Flex alignItems="flex-end" columnGap="1.5rem">
        <Button
          id="import-assets-button"
          variant="outline"
          iconBefore="add-circle"
          onClick={onOpenModal}
          disabled={!enableImageUploadButton}>
          {t('assetImagesGridHeader.addImage')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default AssetImagesGridHeader;
